/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VoucherItem } from "types/entities/VoucherItem";

export interface VoucherReducerState {
    voucherItems: VoucherItem[];
    selectedVoucherItems: VoucherItem[],
    appliedVoucherItems: VoucherItem[];
    selectedVoucher: VoucherItem | null;
}

const initialState: VoucherReducerState = {
    voucherItems: [],
    selectedVoucherItems: [],
    appliedVoucherItems: [],
    selectedVoucher: null,
};

const voucherSlice = createSlice({
    name: 'voucher',
    initialState,
    reducers: {
        pushVoucherItems(state, action: PayloadAction<VoucherItem>) {
            state.voucherItems.push(action.payload)
        },
        setAllVouchersItems(state, action: PayloadAction<VoucherItem[]>) {
            state.selectedVoucherItems = action.payload
        },
        selectVoucherItem(state, action: PayloadAction<VoucherItem | null>) {
            state.selectedVoucher = action.payload
        },
        setVoucherItem(state, action: PayloadAction<VoucherItem>) {
            if (action.payload !== null) {
                const voucherIndex = state.voucherItems.findIndex(voucher => voucher.code === action.payload.code);
                if (voucherIndex === -1) {
                    state.voucherItems.push(action.payload);
                } else {
                    state.voucherItems[voucherIndex].article_id = action.payload.article_id;
                }
            }
        },
        resetAppliedVoucher(state) {
            state.appliedVoucherItems = [];
        },
        resetVoucher(state) {
            state.selectedVoucherItems = [];
            state.voucherItems = [];
            state.appliedVoucherItems = [];
        },
        applyVoucherItems(state, action: PayloadAction<VoucherItem>) {
            if (action.payload !== null) {
                const voucherIndex = state.appliedVoucherItems.findIndex(voucher => voucher.code === action.payload.code);
                if (voucherIndex === -1) {
                    state.appliedVoucherItems.push(action.payload);
                } else {
                    state.appliedVoucherItems[voucherIndex].article_id = action.payload.article_id;
                }
            }
        },
        deleteVoucherItem(state, action: PayloadAction<VoucherItem>) {
            state.voucherItems = state.voucherItems.filter(voucher => voucher.code !== action.payload.code);
        },
        deleteAppliedVoucherItem(state, action: PayloadAction<VoucherItem>) {
            state.appliedVoucherItems = state.appliedVoucherItems.filter(voucher => voucher.code !== action.payload.code);
        },
        resetState: () => initialState,
    }
})

export const {
    pushVoucherItems,
    setAllVouchersItems,
    selectVoucherItem,
    setVoucherItem,
    resetAppliedVoucher,
    resetVoucher,
    applyVoucherItems,
    deleteVoucherItem,
    deleteAppliedVoucherItem,
    resetState,
} = voucherSlice.actions

export default voucherSlice.reducer
